import React from 'react'

const ConsumerOrdersIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="consumerOrdersIcon">
      <path
        d="M27 6H25V5C25 3.346 23.654 2 22 2H10C8.346 2 7 3.346 7 5V6H5C3.897 6 3 6.897 3 8V28C3 29.103 3.897 30 5 30H27C28.103 30 29 29.103 29 28V8C29 6.897 28.103 6 27 6ZM9 5C9 4.449 9.449 4 10 4H22C22.551 4 23 4.449 23 5V6H9V5ZM27 28H5V8H27V28Z"
        fill="#EF8658"
      />
      <path
        d="M10 14H22V16H10V14ZM10 19H22V21H10V19ZM10 24H17V26H10V24Z"
        fill="#EF8658"
      />
    </g>
  </svg>
)

export default ConsumerOrdersIcon
